import 'echarts'

import { startOperateApp } from '@zto/tuxi-operate-web-base'

import { app as appConfig } from './config/app'
import { menus } from './config/menus'
import { ffbs } from './config/ffbs'
import { assets } from './config/assets'
import { commonOptions } from './config/options'
import { apis } from './apis'
import { components } from './components'
import { widgets } from './widgets'
import { pages } from './pages'

import { APP_NAME } from './consts'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

export interface StartAppOptions {
  name?: string
  micro?: boolean
  menus?: any[]
  isZcat?: boolean
}

/** 启动应用 */
export async function startApp(options?: StartAppOptions) {
  const name = options?.name || APP_NAME
  const config = {
    app: appConfig,
    menus,
    assets,
    ...options,
    api: { ffbs },
    apis
  }

  const app = await startOperateApp({
    name,

    pages,
    config,
    extensions: { components, widgets },
    exContext: { options: commonOptions },
    isZcat: options?.isZcat
  })

  // 全局安装VXETable
  app.vueApp.use(useTable)
}

function useTable(app: any) {
  app.use(VXETable)
}
